import { Category } from '@buf/upcyclers_gateway.bufbuild_es/product/v2/product_pb';

import {
  CATEGORY_MAPPINGS,
  IDENTIFIER_MAPPINGS,
  IdentifierMap,
  SUBCATEGORY_MAPPINGS,
  SubCategoryMap,
} from '@lib/product/mappings';
import { Routes } from '@lib/routes';
import {
  HELP_CENTER_LINK,
  FAQ_LINK,
  SELLER_GUIDE_LINK,
} from '@lib/constants/links';

import { CREATIVITY_TOOL, SHOPPABLE_VIDZ, TECHNIQUES, VINTAGE } from './assets';

export const SIDEBAR_NAVIGATIONS = [
  {
    label: CATEGORY_MAPPINGS[Category.CLOTHING]?.label,
    value: Category.CLOTHING,
  },
  {
    label: CATEGORY_MAPPINGS[Category.ACCESSORIES]?.label,
    value: Category.ACCESSORIES,
  },
  {
    label: CATEGORY_MAPPINGS[Category.JEWELRY]?.label,
    value: Category.JEWELRY,
  },
  {
    label: CATEGORY_MAPPINGS[Category.FOOTWEAR]?.label,
    value: Category.FOOTWEAR,
  },
  {
    label: CATEGORY_MAPPINGS[Category.FABRIC]?.label,
    value: Category.FABRIC,
  },
  {
    label: CATEGORY_MAPPINGS[Category.NOTIONS]?.label,
    href: `${Routes.collection}?category=${CATEGORY_MAPPINGS[Category.NOTIONS]?.param}`,
  },
  {
    label: CATEGORY_MAPPINGS[Category.ODDS_AND_ENDS]?.label,
    value: Category.ODDS_AND_ENDS,
  },
  {
    label: 'My Account',
    href: Routes.account,
  },
  {
    label: 'VIDZ',
    href: Routes.videos,
  },
  {
    label: 'About',
    href: Routes.aboutUs,
  },
  {
    label: 'Help Center',
    href: HELP_CENTER_LINK,
  },
];

export const HEADER_NAVIGATIONS = [
  {
    label: CATEGORY_MAPPINGS[Category.CLOTHING]?.label,
    value: Category.CLOTHING,
  },
  {
    label: CATEGORY_MAPPINGS[Category.ACCESSORIES]?.label,
    value: Category.ACCESSORIES,
  },
  {
    label: CATEGORY_MAPPINGS[Category.JEWELRY]?.label,
    value: Category.JEWELRY,
  },
  {
    label: CATEGORY_MAPPINGS[Category.FOOTWEAR]?.label,
    value: Category.FOOTWEAR,
  },
  {
    label: CATEGORY_MAPPINGS[Category.FABRIC]?.label,
    value: Category.FABRIC,
  },
  {
    label: CATEGORY_MAPPINGS[Category.NOTIONS]?.label,
    href: `${Routes.collection}?category=${CATEGORY_MAPPINGS[Category.NOTIONS]?.param}`,
  },
  {
    label: CATEGORY_MAPPINGS[Category.ODDS_AND_ENDS]?.label,
    value: Category.ODDS_AND_ENDS,
  },
  {
    label: 'About',
    href: Routes.aboutUs,
  },
];

export const MAIN_NAVIGATIONS = [
  {
    name: 'Home',
    href: Routes.root,
  },
  {
    name: 'About',
    href: Routes.aboutUs,
  },
  {
    name: 'Join',
    href: Routes.signUp,
  },
];

export const SUPPORT_NAVIGATIONS = [
  {
    name: 'FAQ',
    href: FAQ_LINK,
  },
  {
    name: 'Guide',
    href: SELLER_GUIDE_LINK,
  },
  {
    name: 'Contact Us',
    href: HELP_CENTER_LINK,
  },
];

export const IMAGE_LINKS = [
  {
    title: 'Shoppable Vidz',
    image: SHOPPABLE_VIDZ,
    href: Routes.videos,
  },
  {
    title: 'Techniques',
    image: TECHNIQUES,
    href: Routes.techniques,
  },
  {
    title: 'Creativity Tool',
    image: CREATIVITY_TOOL,
    href: Routes.creativityTool,
  },
  {
    title: 'Vintage',
    image: VINTAGE,
    href: `${Routes.collection}?types=vintage`,
  },
];

type HeaderFilters = {
  [C in Category]?: IdentifierMap[C] | SubCategoryMap[C];
};
export const HEADER_FILTERS: HeaderFilters = {
  [Category.CLOTHING]: IDENTIFIER_MAPPINGS[Category.CLOTHING],
  [Category.ACCESSORIES]: SUBCATEGORY_MAPPINGS[Category.ACCESSORIES],
  [Category.JEWELRY]: SUBCATEGORY_MAPPINGS[Category.JEWELRY],
  [Category.FOOTWEAR]: SUBCATEGORY_MAPPINGS[Category.FOOTWEAR],
  [Category.FABRIC]: SUBCATEGORY_MAPPINGS[Category.FABRIC],
  [Category.NOTIONS]: SUBCATEGORY_MAPPINGS[Category.NOTIONS],
  [Category.ODDS_AND_ENDS]: SUBCATEGORY_MAPPINGS[Category.ODDS_AND_ENDS],
};
